export var ExtentionMethod;
(function (ExtentionMethod) {
    ExtentionMethod["REQUEST_PERMISSION"] = "REQUEST_PERMISSION";
    ExtentionMethod["HAS_PERMISSION"] = "HAS_PERMISSION";
    ExtentionMethod["REPORT_URL"] = "REPORT_URL";
})(ExtentionMethod || (ExtentionMethod = {}));
export const askExtension = (type, value) => {
    parent.postMessage({
        type,
        data: {
            value,
        },
    }, '*');
    return new Promise((resolve) => {
        const listener = (event) => {
            if (event.data.type === type) {
                removeListener();
                resolve(event.data.value);
            }
        };
        const removeListener = () => window.removeEventListener('message', listener);
        window.addEventListener('message', listener);
        setTimeout(() => {
            removeListener();
            resolve(null);
        }, 5000);
    });
};
